<template>
  <b-container>
    <div
      class="vh-100 d-flex flex-column gap-5 bg-light justify-content-center align-items-center"
      v-if="loading"
    >
      <div class="mb-3">
        <b-spinner
          v-for="i in 3"
          :key="i"
          class="mr-1"
          small
          label="Small Spinner"
          type="grow"
        ></b-spinner>
      </div>
      <h3>{{ $t("checkout.placingOrder") }}</h3>
    </div>
    <h3 v-if="isFailed">{{ $t("checkout.wentWrong") }}</h3>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      isFailed: false,
    };
  },
  name: "verify-order",
  computed: {
    ...mapState({
      checkoutData: (state) => state.checkout.checkoutData,
      cartData: (state) => state.checkout.cartData,
      defaultAddress: (state) => state.address.defaultAddress,
      userInfo: (state) => state.auth.userInfo,
      createdOrderData: (state) => state.checkout.createdOrderData,
    }),
  },
  methods: {
    async placeOrderFinal() {
      this.loading = true;
      try {
        let payload = {
          customerDetails: {
            orderAmount: this.checkoutData.totalPrice,
            customerName: this.userInfo.authentication.userName,
            customerPhone: this.userInfo.authentication.phone,
            customerEmail: this.userInfo.authentication.email,
          },
          orderDetails: {
            paymentType: this.checkoutData.payment.type,
            deliveryAddress: {
              ...this.createdOrderData.deliveryAddress,
            },
            items: this.checkoutData.items ? this.checkoutData.items : [],
          },
          createdAt: this.checkoutData.createdAt,
          payments: this.checkoutData.payments,
          payment: this.checkoutData.payment,
          orderHash: this.checkoutData.hash,
          totalPriceBeforeTax: this.checkoutData.totalPriceBeforeTax,
          orderId: this.createdOrderData?.orderId,
        };
        const res = await this.$store.dispatch(
          "checkout/validateOrderAction",
          payload,
        );
        if (res.status !== 200) {
          this.loading = false;
          this.isFailed = true;
          this.$swal({
            title: "Error",
            text: res.data?.message,
            icon: "error",
            confirmButtonText: "OK",
          });
          return;
        }
        this.$router.push({
          name: "order-success",
          params: {
            orderId: res.data?.response?.orderId,
          },
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          text: error.message,
          icon: "error",
          confirmButtonText: "OK",
        });

        this.$router.push({ name: "checkout" });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.placeOrderFinal();
  },
};
</script>
